import buildParams from '../../internal/metrics/buildParams';
import record from '../../internal/metrics/record';
const method = (type)=>{
    return function metricMethod(config, metric, ...params) {
        var _config_metrics;
        if (!config || ((_config_metrics = config.metrics) === null || _config_metrics === void 0 ? void 0 : _config_metrics.disabled)) {
            return;
        }
        const copy = [
            ...params
        ];
        const index = type === 'increment' ? 0 : 1;
        copy[index] = buildParams(config, copy[index]);
        record(config, metric, Object.assign({}, ...copy));
    };
};
export const increment = method('increment');
export const gauge = method('gauge');
export const set = method('set');

//# sourceMappingURL=metrics.server.js.map